import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TouchableOpacity, ViewPropTypes } from 'react-native'
import { Menu } from 'react-native-paper'

import { useTheme } from '../../theming/ThemeProvider'
import { Txt } from '..'
import { usePlatforms } from '../../hooks/usePlatforms'

const MenuNative = ({ children, style, items, itemStyle, textStyle, testID }) => {
  const [show, setShow] = useState()
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()

  const hideMenu = (callback) => {
    setShow(false)
    if (typeof callback === 'function') {
      callback()
    }
  }

  const showMenu = () => setShow(true)
  return (
    <Menu
      visible={show}
      onDismiss={hideMenu}
      anchor={
        <TouchableOpacity testID='menuView' accessibilityLabel='menuView' activeOpacity={0.8} style={style} onPress={showMenu}>
          {children}
        </TouchableOpacity>
      }
      style={{ padding: 0 }}
      contentStyle={{ backgroundColor: theme.CARD_BACKGROUND }}
      testID={testID}
      overlayAccessibilityLabel={testID}
    >
      {
        items.map(({ text, fn, testID: _testID }) => (
          <Menu.Item
            key={text}
            onPress={() => hideMenu(fn)}
            title={(
              <Txt
                testID={testID}
                text={text}
                color='BUNKER'
                identity={isTablet ? 'body2' : 'body1'}
                style={textStyle}
              />
            )}
            style={[
              { height: 40 },
              itemStyle
            ]}
            testID={_testID}
          />
        ))
      }
    </Menu>
  )
}

MenuNative.defaultProps = {
  style: {}
}

MenuNative.propTypes = {
  children: PropTypes.node.isRequired,
  style: ViewPropTypes.style,
  itemStyle: ViewPropTypes.style,
  textStyle: ViewPropTypes.style,
  items: PropTypes.array.isRequired,
  testID: PropTypes.string
}

export default MenuNative
